export default __webpack_public_path__ + "static/media/news2402296.51bbc759.jpg";